module.exports = __webpack_public_path__ + "img/money.8c731d84.png";